// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1IrBj","question":"Question_question__2oqM9","description":"Question_description__3TXM2"};